import { render } from "./RelatorioAeracao.vue?vue&type=template&id=8b9a0362&scoped=true"
import script from "./RelatorioAeracao.vue?vue&type=script&lang=js"
export * from "./RelatorioAeracao.vue?vue&type=script&lang=js"

import "./RelatorioAeracao.vue?vue&type=style&index=0&id=8b9a0362&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b9a0362"]])

export default __exports__